// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1316) return "static/chunks/1316-561eb1a707baf6b0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"421":"8bb348b61a381cd6","8120":"d707da1a32ff1825","8196":"71e80a3393ccd7dd"}[chunkId] + ".js";
};